import Cookies from 'universal-cookie';
import { normalizeLanguage } from './LanguageCode';

const cookies = new Cookies();

export interface UserDefaults {
  language: string;
}

export class CookieUserDefaults implements UserDefaults {
  get language(): string {
    // navigator 帶地區碼（`en-US`、`zh-Hant-TW`）。
    // 這個 getter 是 `LanguageManager` →
    // `App.i18n.changeLanguage()` 的唯一來源，也直接餵給 Google Maps 與
    // 空間地址的 i18n 欄位，所以在這裡就收斂成 i18next 有 resource 的三種語系。
    return normalizeLanguage(
      cookies.get('language') || navigator.language || 'zh-TW'
    );
  }

  set language(language: string) {
    cookies.set('language', language, { path: '/' });
  }
}

const defaults = new CookieUserDefaults();

export default defaults;
